import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Producto/addProducto`, method: 'POST', body: values, token: token})
}